"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbOtpIvr = void 0;
// Types
const types_1 = require("../../../security/authoriser/types");
class MbOtpIvr {
    constructor(api, data, manager) {
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
        this.manager = manager;
    }
    async doTransfer() {
        await this.manager.getMethods().raiseN2OTPInIvr(this.data.otpId, this.progressId);
    }
    async doVerify() {
        return {
            type: types_1.ChallengeType.NONE,
            progressId: this.progressId,
        };
    }
}
exports.MbOtpIvr = MbOtpIvr;
//# sourceMappingURL=otpIvr.js.map